import { render, staticRenderFns } from "./SubCommentEditForm.vue?vue&type=template&id=5fb4d1c8&"
import script from "./SubCommentEditForm.vue?vue&type=script&lang=js&"
export * from "./SubCommentEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports